import store from "../../store";
import {
  setRenewalData,
  setRenewalDetailData,
  setRenewalTitles,
} from "../../store/slices/renewal/renewalSlice";
import api, { api_strapi } from "../../utils/interface";
import { setLoading } from "../../store/slices/commonSlice";
import { toast } from "react-toastify";

export const getRenewalListing = async () => {
  return api
    .post(`agsp/order/renewalActiveOrders`)
    .then((response) => {
      if (response.status === 200) {
        store.dispatch(setRenewalData(response.data));
        return response.data;
      }
    })
    .catch((error) => {
      toast.error(error.response?.data?.error_message || "An error occurred");
    });
};

export const getRenewalDetail = (orderid) => {
  store.dispatch(setRenewalDetailData({}));
  store.dispatch(setLoading(true));

  const fd = new FormData();
  fd.append("order_id", orderid);

  api
    .post(`agsp/order/renwalOrderDetails`, fd)
    .then((response) => {
      if (response.status === 200) {
        store.dispatch(setRenewalDetailData(response.data));
      }
      store.dispatch(setLoading(false));
    })
    .catch((error) => {
      toast.error(error.response?.data?.error_message || "An error occurred");
      store.dispatch(setLoading(false));
    });
};

export const getRenewalTitle = async () => {
  const res = await api_strapi.get(`/renewal`);
  store.dispatch(setRenewalTitles(res?.data?.data?.attributes));
  return res;
};
